module.exports = __webpack_public_path__ + "media/images/icons8-map-48-white-bfc1c1f6e2753bbd6398de985ec9e2b9.png";